

import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { Button, Input } from "@mui/material";
// import { Button, Input, notification } from "antd";
import React, { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";

export const SignalRNotify = () => {
    const [connection, setConnection] = useState<null | HubConnection>(null);
    const [inputText, setInputText] = useState("");

    useEffect(() => {
        onJoinAllNotify();
    }, []);

    const onJoinAllNotify =()=>{
        const connect = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_API_URL + "SignalRChat")
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();

        setConnection(connect);
    }

    const sendMessage = async () => {
        if (connection) {
            let param ={
                Message : inputText
            }
            await connection.invoke("SendMessageNotify", param);

            connection.on("ReceiveNotify", (result) => {

            });

        }
        setInputText("");
    };

    return (
        <>
            <div style={{ padding: '6em 2em' }}>
               <Input
                    value={inputText}
                    onChange={(input) => {
                        setInputText(input.target.value);
                    }}
                />
                <Button onClick={sendMessage}>
                    Send
                </Button>
            </div >

        </>

    );
};